import { render, staticRenderFns } from "./PlantInfo.vue?vue&type=template&id=075728a9&scoped=true&"
import script from "./PlantInfo.vue?vue&type=script&lang=js&"
export * from "./PlantInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlantInfo.vue?vue&type=style&index=0&id=075728a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075728a9",
  null
  
)

export default component.exports